import * as React from "react";
import { useFormContext } from "react-hook-form";
import NGAlert from "../../../newcomponents/alert";
import { DomainInput } from "./types/input";

interface Props {}
export const CreateNGAdvancedAcceptAllDedicatedLBCheck: React.FC<Props> = () => {
  const { watch } = useFormContext<DomainInput>();

  const fAcceptAll = watch("advanced.spec.acceptAll");

  if (fAcceptAll === "hosts") {
    return (
      <NGAlert
        type={`warning`}
        className="mb-4"
        title={`Dedicated Load Balancer is Required`}
        message={`Domain with "acceptAllHosts" value set to true requires Dedicated Load Balancer on the GVC that it is targeting`}
      />
    );
  }

  if (fAcceptAll === "subdomains") {
    return (
      <NGAlert
        type={`warning`}
        className="mb-4"
        title={`Dedicated Load Balancer is Required`}
        message={`Domain with "acceptAllSubdomains" value set to true requires Dedicated Load Balancer on the GVC that it is targeting`}
      />
    );
  }

  return null;
};
